import { TipoDocumento } from './tipo-documento';
export class AtoPort {
  idPort: number = null; //
  anoPort: number = null; //Ano da Portaria
  assina: string = null; //
  dataEfeito: Date = null; //
  bloqueado: string = null; //
  codServ: number = null; //
  dataPub: Date = null; //
  nroPort: number = null; //N�mero da portaria
  dataPort: Date = null; //
  dataPubDo: Date = null; //
  dataRetifica: Date = null; //
  descPort: string = null; //
  extensao: string = null; //
  exportado: string = null; //
  idDocumento: number = null; //
  funcAssina: string = null; //
  fkCodDoc: number = null; //
  idDoe: number = null; //
  idDoejt: number = null; //
  internet: string = null; //
  tipoPort: string = null; //Indica se Portaria ou Ato
  origPort: string = null; //
  nomeUsu: string = null; //
  localPub: string = null; //
  nomeUsuPub: string = null; //
  semEfeito: string = null; //
  publico: string = null; //
  retifica: string = null; //
  siglaPort: string = null; //
  textoBi: string = null; //
  tipoPublicacao: TipoDocumento = null; //
  tipoPub: string = null; //
  gerouEfeito: number = null;
  sofreuEfeito: number = null;

  //textoPort: string = null; //
  //idEfeito: number = null; //
  //idRetifica: number = null; //
  //idTipoPort: number = null; //
  //fkDocProad: number = null; //

  constructor(d?) {
    this.idPort = d.idPort ? d.idPort : null;
    this.nroPort = d.nroPort ? d.nroPort : null;
    this.anoPort = d.anoPort ? d.anoPort : null;
    this.dataPort = d.dataPort ? new Date(d.dataPort) : null;
    this.tipoPort = d.tipoPort ? d.tipoPort : null;
    this.origPort = d.origPort ? d.origPort : null;
    this.dataPub = d.dataPub ? new Date(d.dataPub) : null;
    this.dataEfeito = d.dataEfeito ? new Date(d.dataEfeito) : null;
    this.semEfeito = d.semEfeito ? d.semEfeito : null;
    this.siglaPort = d.siglaPort ? d.siglaPort : null;
    this.descPort = d.descPort ? d.descPort : null;
    this.extensao = d.extensao ? d.extensao : null;
    this.publico = d.publico ? d.publico : null;
    this.tipoPub = d.tipoPub ? d.tipoPub : null;
    this.nomeUsuPub = d.nomeUsuPub ? d.nomeUsuPub : null;
    this.nomeUsu = d.nomeUsu ? d.nomeUsu : null;
    this.assina = d.assina ? d.assina : null;
    this.localPub = d.localPub ? d.localPub : null;
    this.dataPubDo = d.dataPubDo ? new Date(d.dataPubDo) : null;
    this.funcAssina = d.funcAssina ? d.funcAssina : null;
    this.retifica = d.retifica ? d.retifica : null;
    this.dataRetifica = d.dataRetifica ? new Date(d.dataRetifica) : null;
    this.textoBi = d.textoBi ? d.textoBi : null;
    this.bloqueado = d.bloqueado ? d.bloqueado : null;
    this.internet = d.internet ? d.internet : null;
    this.idDoe = d.idDoe ? d.idDoe : null;
    this.idDoejt = d.idDoejt ? d.idDoejt : null;
    this.idDocumento = d.idDocumento ? d.idDocumento : null;
    this.codServ = d.codServ ? d.codServ : null;
    this.exportado = d.exportado ? d.exportado : null;
    this.gerouEfeito = d.gerouEfeito ? d.gerouEfeito : null;
    this.sofreuEfeito = d.sofreuEfeito ? d.sofreuEfeito : null;
    this.tipoPublicacao = d.tipoPublicacao
      ? new TipoDocumento(d.tipoPublicacao)
      : null;
    this.fkCodDoc = d.fkCodDoc ? d.fkCodDoc : null;
  }

  public getTitulo(): string {
    //console.log(this);
    let str = this.tipoPublicacao ? this.tipoPublicacao.dsTipodocumento : '';
    //console.log(str);
    str = str + (this.origPort ? ' - ' + this.origPort : '');
    str = str + ' ' + this.nroPort + '/' + this.anoPort;

    return str;
  }
}
